import {
  Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, TextField
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { loadUrunControlDetail, saveUrunControlDetail } from 'src/utils/storage/StartWorkOrder';
import UrunSearch from '../../components/Selects/ProductSearch';
import {
  getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials
} from '../../store/actions';

const useStyles = makeStyles((theme) => ({
  rootProductControl: {},
  avatarProductControl: {
    backgroundColor: red[500],
  },
  fieldsProductControl: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policyProductControl: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckboxProductControl: {
    marginLeft: '-14px'
  },
  submitButtonProductControl: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  contentProductControl: {
    padding: 0,
  },
}));

function ProductControl({
  className, FisNo, readonly, tasks, getDefectRequest, getLabourRequest, getMaterialRequest, resetDefects, resetLabours, resetMaterials
}) {
  const [openProductControl, setOpenProductControl] = React.useState(false);
  const [UyariProductControl, setUyariProductControl] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation('product_detail_control');
  const [UrunDataProductControl, setUrunDataProductControl] = useState({});
  // const [searchProductControl, setSearchProductControl] = useState('');
  const todayProductControl = new Date();
  const maxYilProductControl = todayProductControl.getFullYear();

  // const [formValidProductControl, setFormValidProductControl] = useState(true);
  const [formStateProductControl, setFormStateProductControl] = useState([
    {
      name: 'SERINO',
      min: 0,
      max: 9999999999,
      valid: true,
      errorMessage: t('error_message_serino')
    },
    {
      name: 'UYIL',
      min: 0,
      max: maxYilProductControl,
      valid: true,
      errorMessage: t('error_message_uyil').replace('@maxYil', maxYilProductControl)
    },
    {
      name: 'UDONEM',
      max: 12,
      min: 0,
      valid: true,
      errorMessage: t('error_message_udonem')
    }
  ]);


  useEffect(() => {
    const storeDataProductControl = loadUrunControlDetail();
    if (storeDataProductControl.length !== 0) {
      setUrunDataProductControl(storeDataProductControl[0]);
    } else {
      setUrunDataProductControl({});
    }
  }, []);

  const handleChangeProductControl = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    let tmpValid = true;
    for (let i = 0; i < formStateProductControl.length; i++) {
      const obj = formStateProductControl[i];
      if (obj.name === name && value) {
        if (value > obj.max || value <= obj.min) {
          setFormStateProductControl([...formStateProductControl.slice(0, i), { ...obj, valid: false }, ...formStateProductControl.slice(i + 1)]);
        } else {
          setFormStateProductControl([...formStateProductControl.slice(0, i), { ...obj, valid: true }, ...formStateProductControl.slice(i + 1)]);
        }
      }
      tmpValid = tmpValid && obj.valid;
    }
    // setFormValidProductControl(tmpValid);

    const obj = formStateProductControl.filter((f) => f.name === name)[0];
    if (parseInt(value) > obj.min && parseInt(value) <= obj.max) {
      let job = UrunDataProductControl;
      job = { ...job, [name]: value };
      setUrunDataProductControl(job);
      saveUrunControlDetail(job);
    } else {
      let job = UrunDataProductControl;
      job = { ...job, [name]: obj.min };
      setUrunDataProductControl(job);
      saveUrunControlDetail(job);
    }
  };

  const setModel = (param) => {
    let job = loadUrunControlDetail()[0];
    setUyariProductControl(t('warning_message_product_change'));
    setOpenProductControl(true);
    resetLabours(param.KUL_MODEL_KODU);
    resetDefects();
    resetMaterials(param.KUL_MODEL_KODU);
    getDefectRequest(param.KUL_MODEL_KODU, 1);
    getMaterialRequest(param.KUL_MODEL_KODU, 1, 1, UrunDataProductControl.UYIL || 0, UrunDataProductControl.UDONEM || 0,job.ReceiptNo);
    getLabourRequest(param.KUL_MODEL_KODU, 1, 1,job.ReceiptNo);
    job = {
      ...job,
      KUL_MODEL_KODU: param.KUL_MODEL_KODU,
      MODEL: param.ACIKLAMA,
      HOMEWHIZ: param.HOMEWHIZ,
      MARKA_KODU: param.MARKA_KODU,
    };
    setUrunDataProductControl(job);
    saveUrunControlDetail(job);
  };

  const handleClose = () => {
    setOpenProductControl(false);
  };


  return (
    <Card
      className={clsx(classes.rootProductControl, className)}
    >
      <CardHeader title={t('title2')} />
      <Divider />
      <CardContent className={classes.contentProductControl}>
        <Dialog
          open={openProductControl}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {UyariProductControl}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        <form
          className={clsx(classes.rootProductControl, className)}
        >
          <div className={classes.fieldsProductControl}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <UrunSearch
                  setModel={setModel}
                  value={{
                    KUL_MODEL_KODU: UrunDataProductControl.KUL_MODEL_KODU,
                    ACIKLAMA: UrunDataProductControl.MODEL
                  } || ''}
                  searchParam=""
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={t('uyil')}
                  name="UYIL"
                  type="number"
                  value={UrunDataProductControl.UYIL || ''}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter((n) => n.name === 'UYIL')[0].valid}
                  helperText={formStateProductControl.filter((n) => n.name === 'UYIL')[0].valid ? '' : formStateProductControl.filter((n) => n.name === 'UYIL')[0].errorMessage}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  label={t('udonem')}
                  name="UDONEM"
                  value={UrunDataProductControl.UDONEM || ''}
                  type="number"
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter((n) => n.name === 'UDONEM')[0].valid}
                  helperText={formStateProductControl.filter((n) => n.name === 'UDONEM')[0].valid ? '' : formStateProductControl.filter((n) => n.name === 'UDONEM')[0].errorMessage}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={t('serino')}
                  name="SERINO"
                  type="number"
                  value={UrunDataProductControl.SERINO || ''}
                  fullWidth
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={handleChangeProductControl}
                  variant="outlined"
                  error={!formStateProductControl.filter((n) => n.name === 'SERINO')[0].valid}
                  helperText={formStateProductControl.filter((n) => n.name === 'SERINO')[0].valid ? '' : formStateProductControl.filter((n) => n.name === 'SERINO')[0].errorMessage}
                />
              </Grid>
            </Grid>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}

ProductControl.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    resetLabours, resetDefects, resetMaterials, getDefectRequest, getLabourRequest, getMaterialRequest
  }
)(ProductControl);
